<template>
  <HeaderComponent />
  <v-container class="info-container">
    <v-row class="mb-0">
      <v-col cols="10" md="6" class="d-flex align-center">
        <h1 class="text-h5 text-md-h4 teal-darken-3">Stock</h1>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="6" class="pt-0 pb-2">
        <v-text-field
          v-model="searchNombre"
          hide-details="auto"
          label="Filtrar por nombre"
          prepend-inner-icon="mdi-filter"
          variant="outlined"
          clearable
        />
      </v-col>
      <v-col cols="6" class="pt-0 pb-2">
        <v-text-field
          v-model="searchBodega"
          hide-details="auto"
          label="Filtrar por bodega"
          prepend-inner-icon="mdi-filter"
          variant="outlined"
          clearable
        />
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12">
        <v-card>
          <v-table class="teal-darken-3" density="comfortable">
            <thead>
              <tr>
                <th class="font-weight-bold text-uppercase">Nombre</th>
                <th class="font-weight-bold text-uppercase">Añada</th>
                <th class="font-weight-bold text-uppercase">Bodega</th>
                <th class="font-weight-bold text-uppercase">Cantidad</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="stock in filteredStocks" :key="stock.id" class="teal-darken-3">
                <td class="py-3">{{ stock.name }}</td>
                <td class="py-3">{{ stock.vintage }}</td>
                <td class="py-3">{{ stock.bodegaId.name }}</td>
                <td class="py-3">{{ stock.quantity }}</td>
                <td class="py-3" style="text-align: right">
                  <v-btn
                    variant="outlined"
                    icon
                    color="teal-darken-3"
                    size="small"
                    @click="showAgregarStock(stock)"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-card>
      </v-col>
    </v-row>
    <AgregarStockDialogComponent
      v-model="showDialogAgregarStock"
      :stockToUpdate="stockToUpdate"
      @created="actualizarStock"
      @alert="showAlert"
    />
    <AlertComponent
      v-model="alertVisible"
      :text="alertText"
      :type="alertType"
      :sendLogin="alertSendLogin"
      @update:modelValue="handleAlertClose"
    />
  </v-container>
</template>

<script setup>
import { onBeforeMount, ref, computed } from "vue";
import { useRouter } from "vue-router";

import AgregarStockDialogComponent from "@/components/dialog/AgregarStockDialogComponent.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";

import EtiquetaService from "@/services/EtiquetaService.js";
import AuthService from "@/services/AuthService.js";

const router = useRouter();

import { useAuthStore } from "@/stores/auth.js";

const auth = useAuthStore();

const loaded = ref(false);
const stocks = ref([]);
const searchNombre = ref("");
const searchBodega = ref("");
const showDialogAgregarStock = ref(false);
const stockToUpdate = ref(null);
const alertVisible = ref(false);
const alertText = ref("");
const alertType = ref("warning");
const alertSendLogin = ref(false);

onBeforeMount(() => {
  actualizarInfo();
});

async function actualizarInfo() {
  await refreshAuth();
  await getListStocks();
  loaded.value = true;
}

const filteredStocks = computed(() => {
  if (!searchNombre.value) return stocks.value;
  return stocks.value.filter((stock) =>
    stock.name.toLowerCase().includes(searchNombre.value.toLowerCase())
  );
});

const showAgregarStock = async (stock = null) => {
  stockToUpdate.value = stock;
  showDialogAgregarStock.value = true;
};

const showAlert = (message) => {
  alertText.value = message;
  alertVisible.value = true;
};

const actualizarStock = async (datosEditados) => {
  try {
    await refreshAuth();
    await EtiquetaService.updateStock(
      datosEditados._id,
      datosEditados.quantity,
      auth.token
    );
    await actualizarInfo();
    showDialogAgregarStock.value = false;
  } catch (error) {
    alertText.value =
      "No pudimos agregar la stock. Por favor, inténtalo de nuevo mas tarde.";
    alertVisible.value = true;
  }
};

const getListStocks = async () => {
  try {
    const response = await EtiquetaService.getList(auth.token);
    stocks.value = response.data.etiquetas;
  } catch (error) {
    alertText.value =
      "No pudimos cargar las etiqietas. Por favor, inténtalo de nuevo más tarde.";
    alertVisible.value = true;
  }
};

const refreshAuth = async () => {
  try {
    const response = await AuthService.refreshToken();
    auth.setToken(response.data.token);
  } catch (error) {
    alertText.value =
      "Acceso restringido. Esta función no está disponible para tu perfil.";
    alertVisible.value = true;
    alertType.value = "warning";
    alertSendLogin.value = true;
  }
};

const handleAlertClose = (newValue, sendToLogin) => {
  if (sendToLogin) {
    router.push("/");
  }
  alertVisible.value = newValue;
};
</script>

<style scoped>
.teal-darken-3 {
  color: #00695c;
}
</style>
